/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles.module.css'
import logoImg from 'images/windlab-logo.png'

const Logo = ({ className }) => (
  <aside id="logoContainer" className={cx(className, styles.Logo)}>
    <img className={styles.logoImg} src={logoImg} alt="CPP Wind Engineering" />
  </aside>
)

Logo.propTypes = {
  className: PropTypes.string,
}

export default Logo
